export function homepageBanner() {
  const banner = document.querySelector('.block--homepage-banner');

  if (banner) {
    const headers = banner.querySelectorAll('h2');
    let index = 0;

    setInterval(() => {
      const header1 = headers[index % headers.length];
      const header2 = headers[(index+1) % headers.length];
      header1.style.opacity = '0';
      header2.style.opacity = '1';
      index++;
    }, 3000);
  }
}
